export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-1-90cc5f3ab91b712a9c2e2be9b38823f6.png";